import React from 'react'
import styles, { layout } from '../../style'
import { aws, screen, python } from '../../assets'


const Billing = () => {
  return (
    <section id="product" className={layout.sectionReverse}>
      <div
        className={layout.sectionImgReverse}>
          <img src={screen} alt="billing" className='w-[100%] h-[100%] relative z-[5]' />
      </div>
      <div className='absolute z-[3] -left-1/2 top-0 w-[50%] rounded-full white__gradient' />
      <div className='absolute z-[3] -left-1/2 bottom-0 w-[50%] rounded-full pink__gradient' />

      <div className={layout.sectionInfo}>
        <h2 className={styles.heading2}>The first "Media Arbitrage Platform" <br className='sm:block hidden'/> 
          leveraging our world-class Data Ecosystem.
        </h2>
        <p className={`${styles.paragraph} max-w-[470px] mt-5`}>
        We needed to build this solution for our portfolio of companies 
        at our Single Family Office. We found that leveraging the five 
        major arbitrages (we created) has exponentially unlocked new 
        opportunities for growth in our portfolio of companies. 
        What we've done is hard, but we've done it. Do you have the 
        combination of "arbitrages" you need to compete in this market?
        </p>
        <div className='flex flex-row flex-wrap sm:mt-10 mt-6'>
          <img src={aws} alt="aws_powered"
            className='w-[128px] h-[42px] object-contain mr-5 cursor-pointer' />
          <img src={python} alt="python_powered"
            className='w-[128px] h-[42px] object-contain mr-5 cursor-pointer' />
        </div>
      </div>
    </section>
  )
}

export default Billing